import { useQuery } from "@tanstack/react-query";
import { getEnquiryApi } from "./enquiry.api";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { IGetAllServiceProps } from "@api/types/globalService.types";

type IGetEnquiryServiceProps = Omit<
  IGetAllServiceProps,
  "page" | "per_page" | "stage_id"
>;
const useGetEnquiryService = ({
  enableQuery = true,
  cacheKeys = [],
  filters = {},
}: IGetEnquiryServiceProps) => {
  return useQuery({
    queryKey: [...CACHE_KEYS.ENQUIRIES, ...cacheKeys],
    queryFn: () =>
      getEnquiryApi({
        searchParams: {
          ...filters,
        },
      }),
    enabled: enableQuery,
    staleTime: 0,
  });
};

export { useGetEnquiryService };
